<template>

  <b-modal
    v-model="isVisible"
    hide-footer
    :size="isAuditoria ? 'xl' : 'lg'"
  >
    <div class="row">

      <!-- {{ 'token atencion ' + tokenAtencion }} -->

      <div class="col-12">
        <b-alert show class="p-2">
          <div v-if="atencionMedica" class="row">
            <div class="col">
              <h5> <b> Establecimiento: </b> {{ atencionMedica.cita.establecimiento.Descripcion }}</h5>
              <h5> <b> Doctor: </b> {{ doctor.nombre }}</h5>
            </div>
            
            <div class="col">
              <h5> <b> Paciente: </b> {{ paciente.identificacion}} - {{ paciente.nombre }}</h5>
              <h5> <b> Especialidad: </b> {{ doctor.especialidad }}</h5>
            </div>
          </div> 
        </b-alert>
      </div>
      
      
      <div
        v-if="isEditable"
        class="col-12 d-flex justify-content-end"
      >
        <b-button
          variant="warning"
          @click="onRedirectToEditAtencion"
        >
          Editar Atencion
        </b-button>
      </div> 

      <div class="col-4 mt-2" v-if="isAuditoria">
        <HistorialAtenciones 
          v-if="idPaciente"
          :idPaciente = "idPaciente"
        />

        <HistorialImagenesLabs
          v-if="idPaciente"
          :idPaciente = "idPaciente"
        />
      </div>

      <div :class="isAuditoria ? 'col-8' : 'col-12'">

        <AtencionAnamnesis
          :tokenAtencion="tokenAtencion"
          :isAuditoria="isAuditoria"
        />

  
        <AtencionReceta
          :tokenAtencion="tokenAtencion"
          :isAuditoria="isAuditoria"
        />
  
        <AtencionExamenes
          :tokenAtencion="tokenAtencion"
          :isAuditoria="isAuditoria"
        />
  
        <AtencionImagenes
          :tokenAtencion="tokenAtencion"
          :isAuditoria="isAuditoria"
        />
  
        <AtencionTerapias
          :tokenAtencion="tokenAtencion"
          :isAuditoria="isAuditoria"
        />
  
        <AtencionProcedimientos
          :tokenAtencion="tokenAtencion"
          :isAuditoria="isAuditoria"
        />
  
        <AtencionDescansoMedico
          :tokenAtencion="tokenAtencion"
          :isAuditoria="isAuditoria"
        />

        <b-card v-if="isAuditoria">
          <b-row>
            <b-col>
              <b>Documento As400: </b>

              <b-button
                v-if="docAs400Show"
                @click="onViewFile(docAs400Show)"
                variant="warning"
              >
                Ver archivo
              </b-button>

              <span v-if="!docAs400Show">No hay archivo</span>

              <!-- {{docAs400Show}} -->

            </b-col>
          </b-row>
          
        </b-card> 

        <b-card v-if="isAuditoria">
          <div class="row d-flex align-items-center justify-content-center">
            <div>
              <h5 class="text-center">Firma del Paciente:</h5>
              <div style="border: 1px solid #2980b9">
                <div
                  v-if="!base64Signature"
                  style="width: 400px; height: 150px; font-size: 40px;"
                  class="d-flex align-items-center justify-content-center"
                >
                  Sin firma
                </div>

                <img
                  v-if="base64Signature"
                  :src="base64Signature" 
                  alt="Firma paciente" 
                />
              </div>
            </div>
          </div>
        </b-card>
      </div> 


      

    </div>

    <ModalViewFile
      v-if="fileToView"
      :urlFile="fileToView"
      v-model="isModalFileVisible"
    />

  </b-modal>
  
</template>

<script>
import { ModalViewFile }         from '@/shared/components';
import { HistorialAtenciones, HistorialImagenesLabs }     from "@/views/atencionCita/components";
import AtencionAnamnesis         from "@/views/atencionMedica/components/AtencionModalView/AtencionAnamnesis.vue";
import AtencionReceta            from "@/views/atencionMedica/components/AtencionModalView/AtencionReceta.vue";
import AtencionExamenes          from "@/views/atencionMedica/components/AtencionModalView/AtencionExamenes.vue";
import AtencionProcedimientos    from "@/views/atencionMedica/components/AtencionModalView/AtencionProcedimientos.vue";
import AtencionImagenes          from "@/views/atencionMedica/components/AtencionModalView/AtencionImagenes.vue";
import AtencionTerapias          from "@/views/atencionMedica/components/AtencionModalView/AtencionTerapias.vue";
import AtencionDescansoMedico    from "@/views/atencionMedica/components/AtencionModalView/AtencionDescansoMedico.vue";
import { atencionMedicaService } from '@/views/atencionMedica/services';
import { mapperAtencionMedica }  from '@/views/atencionMedica/helpers';
import SemiologiaPsicologica from '../Anamnesis/Semiologias/SemiologiaPsicologica/SemiologiaPsicologica.vue';

export default {

  name: "HistorialAtencionModal",

  props: {
    isAuditoria: Boolean
  },

  components: {
    AtencionAnamnesis,
    AtencionReceta,
    AtencionExamenes,
    AtencionProcedimientos,
    AtencionImagenes,
    AtencionTerapias,
    AtencionDescansoMedico,
    ModalViewFile,
    HistorialImagenesLabs,
    HistorialAtenciones,
    SemiologiaPsicologica
  },

  created() {
    this.setTokenView();
  },
  
  data() {
    return {
      dataSemio:null,
      dataPsico:null,
      isViewModal:true,
      isVisible: false,
      atencionMedica: null,
      tokenView:null,

      fileToView: null,
      isModalFileVisible: false,

      isEditable: false,
    };
  },

  computed: {

    tokenAtencion(){
      return this.atencionMedica?.token;
    },

    tokenAnamnesis() {
      return this.atencionMedica?.anamnesis.token;
    },

    tokenReceta(){
      return this.atencionMedica?.receta 
        ? this.atencionMedica?.receta.token
        : '000'
    },

    doctor(){
      const doctor = this.atencionMedica?.cita.doctor;
      return {
        nombre:`${doctor.idPersona.primerApellido}  ${doctor.idPersona.primerNombre}`,
        especialidad: doctor.especialidad.descripcion
      }
    },

    paciente(){
      const paciente = this.atencionMedica?.cita.paciente.persona;

      return {
        nombre:`${paciente.primerApellido}  ${paciente.primerNombre}`,
        identificacion: paciente.identificacion
      }
    },

    idPaciente() {
      return this.atencionMedica?.cita.paciente.id;
    },

    base64Signature() {
      if (!this.atencionMedica?.signature) return null

      return  `data:image/png;base64,${this.atencionMedica?.signature}`;
    },

    docAs400Show(){
      if (!this.atencionMedica?.docAs400) return null;
      const lastDoc = this.atencionMedica?.docAs400[this.atencionMedica?.docAs400.length - 1];
      if (!lastDoc) return null;
      return lastDoc.urlsDocAs400;
    },

  },
  
  
  methods: {

    onRedirectToEditAtencion() {
      this.$router.push({
        name: "editar_atencion_medica",
        params: { token: this.tokenView }
      });
    },

    onViewFile(urlF) { 
      this.fileToView = urlF;
      this.isModalFileVisible = true;
    },

    hasPermission(permission) {
      const permisosUsuario = localStorage.getItem("permisos");
      return permisosUsuario.indexOf(permission) !== -1;
    },


    async onGetDataView( tokenAtencion ){
      this.isEditable = false;
      const data = await atencionMedicaService.getByToken(tokenAtencion);

      if (!data){
        this.$swal("Error", "La atencion no existe.", "error")
          .then(
            () => this.$router.push({ name: 'atenciones-medicas' })
          );
        return;
      }

      this.atencionMedica = mapperAtencionMedica( data );
      this.$store.commit("setRevision", { tokenAtencion:this.tokenAtencion });
      this.isVisible = true;

      this.isEditable = this.atencionMedica.estadoRevision === '1';
    },

    setTokenView(){
      this.tokenView = this.$route.query.view_atencion_historial; 
    }
  },




  watch: {

    '$route.query.view_atencion_historial': {
      handler(){ 
        this.setTokenView();
      },
    },

    tokenView:{
      deep:true,
      handler(newValue){
        if(!newValue) return;
        this.onGetDataView( newValue );
      }
    },


    isVisible: {
      deep: true,
      handler(newValue) {
        if (!newValue) {
          const updatedQuery = { ...this.$route.query };
          delete updatedQuery.view_atencion_historial;
          this.$router.push({ path: this.$route.path, query: updatedQuery });
        }
      }
    },

    atencionMedica: {
      deep:true,
      inmediate:true,
      handler(nv){
        if(nv && nv.semiologia){
          try{
            this.dataSemio = JSON.parse(nv.semiologia)
          }catch(error){console.log(error)}
        }
      }
    },

    dataSemio:{
      deep:true,
      inmediate:true,
      handler(nv){
        if(nv.tipo = 'psico'){
          this.dataPsico = nv.data
        }
      }
    }

  },

};
</script>
 